import { useUserStoryUploadFlow } from '@src/stores-v2/StoreContext';
import { useMemo } from 'react';

export const useUploadPhase = (storyId?: string) => {
  const store = useUserStoryUploadFlow();
  return useMemo(() => {
    const phase = store.getStoryUploadPhase(storyId);
    let percent: number | undefined;
    if (phase.phase === 'uploading') percent = phase.progress;
    if (phase.phase === 'processing') percent = 100; // show full bar beneath spinner
    return { phase, percent };
  }, [
    store,
    storyId,
    store.storyUploadPhaseRecord[storyId || 'story-from-modal'],
  ]);
};

export default useUploadPhase;
